import {Component, Input} from '@angular/core';
import {AdsTxtStatus, AdsTxtStatusLabels} from '../../domain/adstxt-status.model';

@Component({
  selector: 'cm-adstxt-status-icon',
  template: `
    <span class="adstxt-status-icon" [matTooltip]="AdsTxtStatusLabels[status]">
      <i class="fas fa-check text-success" *ngIf="status!==AdsTxtStatus.NOT_EXIST"></i>
      <i class="fas fa-times text-danger" *ngIf="status==AdsTxtStatus.NOT_EXIST"></i>
    </span>
  `,
  styles: [`
    .adstxt-status-icon {
      font-size: 14px;
    }
  `],
  host: {'class': 'cm-adstxt-status-icon'}
})
export class AdstxtStatusIconComponent {

  @Input()
  public status: AdsTxtStatus;

  AdsTxtStatus = AdsTxtStatus;
  AdsTxtStatusLabels = AdsTxtStatusLabels;

}
